export default __webpack_public_path__ + "static/media/991.d8f65d92.jpg";